<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Purchase No：{{
            formData.amzPurchaseDemandNo ? formData.amzPurchaseDemandNo : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.amzPurchaseDemandStatus === 'N'
              ? 'primary'
              : formData.amzPurchaseDemandStatus === 'S'
              ? 'warning'
              : formData.amzPurchaseDemandStatus === 'Y'
              ? 'success'
              : formData.amzPurchaseDemandStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_amzPurchaseDemandStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_demandDate') || '需求日期'"
            prop="demandDate"
          >
            <el-date-picker
              v-model="formData.demandDate"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_operateName') || '运营人员'">
            <dict-select
              v-model="formData.operateCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.operateName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SkuTable
      :amzPurchaseDemandCode="amzPurchaseDemandCode"
      :disabled="disabled"
    />
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
export default {
  mixins: [EditLoading],
  components: {SkuTable},
  props: {
    amzPurchaseDemandCode: {type: String, default: ''},
    disabled: {type: Boolean, default: true},
  },
  data() {
    return {
      formData: {},
      rules: {
        demandDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.amzPurchaseDemandCode) return
      this.$api
        .ecomAmzPurchaseDemandDetailApi({
          amzPurchaseDemandCode: this.amzPurchaseDemandCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()

      this.$api
        .ecomAmzPurchaseDemandSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const {status} = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.amzPurchaseDemandCode) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
